var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2751 5.39131C16.5192 5.63539 16.5192 6.03112 16.2751 6.27519L7.94178 14.6085C7.6977 14.8526 7.30197 14.8526 7.0579 14.6085L3.72456 11.2752C3.48048 11.0311 3.48048 10.6354 3.72456 10.3913C3.96864 10.1472 4.36437 10.1472 4.60845 10.3913L7.49984 13.2827L15.3912 5.39131C15.6353 5.14723 16.031 5.14723 16.2751 5.39131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.32f674b132265c2576480ce13884ec5d.svg";
export { ForwardRef as ReactComponent };